import { AlgoliaAdminOrder } from '@models/Algolia'

/** Will display the action based on the order status. Should only have actions for draft orders */
export const formatOrderAction = (ord: AlgoliaAdminOrder) => {
  if (!ord.isDraft) return ''
  if (ord.status === 'Pending') return 'Approve'
  if (ord.status === 'Approved') return 'Fulfill'
  return ''
}
